<template>
  <div class="privatplace transfer__wrapper" :class="{ 'with-scroll': withScroll }">
    <form-layout
      :main-title="$t('transfer.title')"
      :mobile-title="$t('transfer.titleMobile')"
      :small-title="true"
      :title="$t('transfer.placeTitle')"
      :disabled="!placeId"
      @back="goToTransferCharacters"
      @submit="changeModal"
    >
      <div class="transfer__form">
        <div class="transfer__form-content">
          <div class="transfer__form-content__notFound" v-if="isLoadedPlace === true && placesLength === 0">
            <img src="@/assets/images/transfer/notFound.svg" alt="" />
            <p>Не нашли публичных плейсов у этого персонажа</p>
          </div>
          <Loader v-if="!isLoadedPlace" />
          <div
            v-if="isLoadedPlace && placesLength"
            class="transfer__form-content__wrapper"
            :class="{ 'with-scroll': withScroll }"
          >
            <BaseCard
              v-for="(value, key) in places"
              :key="key"
              :title="value.name"
              :image="value.imageUrl"
              :active="uid === value.UniverseID"
              is-place
              @click="selectPlace(key, value.name, value.UniverseID)"
            />
          </div>
          <!--          <Button class="transfer__form-content__btn" @click="openPlaceModal" type="secondary" size="md">-->
          <!--            НЕТ НУЖНОГО ПЛЕЙСА ?-->
          <!--          </Button>-->
        </div>
      </div>
    </form-layout>
    <PlaceModal
      v-if="isShowPlaceModal"
      :fetchPlaces="getPlaces"
      :placesLength="placesLength"
      :accountId="robloxUserId"
      @close="isShowPlaceModal = false"
    />
  </div>
</template>

<script>
import FormLayout from '@/components/Base/FormLayout/FormLayout.vue'

import BaseCard from '@/components/BaseCard/BaseCard.vue'
import Loader from '@/components/LoaderBar/LoaderBar.vue'
import PlaceModal from '@/components/Modals/Place/PlaceModal.vue'
import windowSize from '@/mixins/windowSize'

export default {
  name: 'TransferPrivatPlace',
  mixins: [windowSize],
  components: {
    PlaceModal,
    Loader,
    BaseCard,
    FormLayout
  },
  props: ['robloxUserId', 'data'],
  data() {
    return {
      isSelectPlace: false,
      places: [],
      placeId: null,
      placeName: '',
      uid: '',
      isLoadedPlace: false,
      isShowPlaceModal: false
    }
  },
  created() {
    this.getPlaces()
  },
  mounted() {
    this.$store.commit('setScipGamepass', false)
  },
  computed: {
    placesLength() {
      return this.places.length || Object.keys(this.places).length
    },
    withScroll() {
      return this.placesLength >= 3
    },
    totalRobuxFromUser() {
      return this.data?.bonusForGamepass
        ? Number(this.data.totalRobux) + Number(this.data.bonusForGamepass)
        : this.data?.totalRobux || 0
    },
    expectedGamepassPrice() {
      return Math.round(this.totalRobuxFromUser / 0.7)
    }
  },
  methods: {
    checkLengthPlaces(currentLength) {
      if (currentLength === this.placesLength) {
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description:
            this.screenWidth < 743 ? this.$t('modals.place.notificationMob') : this.$t('modals.place.notification'),
          type: 'error'
        })
      } else {
        this.isShowPlaceModal = false
      }
    },

    setFirstPlace() {
      const keys = Object.keys(this.places)

      if (keys.length > 0) {
        const firstKey = keys[0]
        const firstPlace = this.places[firstKey]
        const { name, UniverseID } = firstPlace

        this.selectPlace(firstKey, name, UniverseID)
      }
    },
    async getPlaces() {
      this.isLoadedPlace = false
      const res = await fetch(`https://transfer.backend-pier.com/get_places/${this.robloxUserId}`)
      const data = await res.json()
      if (data.status) {
        this.isLoadedPlace = true
        this.checkLengthPlaces(Object.keys(data.data)?.length)
        this.places = data.data
        this.setFirstPlace()
      }
    },
    async changeModal() {
      if (!this.placeId) {
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: this.$t('transfer.placeTitle'),
          type: 'error'
        })
        return
      }

      if (this.isSelectPlace) {
        this.$analytics.send('purch_trans_3_place', {})

        // Проверка авторизации
        if (!this.$store.state.isAuth) {
          this.$emit('changeModal', {
            modal: 'SignIn',
            data: [this.placeId, this.placeName, this.uid]
          })
          return
        }

        // Проверка настройки Game Pass
        this.isLoadedPlace = false
        const gamepassCheckResult = await this.checkGamepassSetup()
        this.isLoadedPlace = true

        if (!gamepassCheckResult.isConfigured) {
          // Game Pass не настроен - идём на инструкцию
          this.$emit('changeModal', {
            modal: 'TransferInstructionGamepass',
            data: [this.placeId, this.placeName, this.uid]
          })
          return
        }

        await this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.success'),
          description: this.$t('transfer.gamepass.successHint'),
          type: 'success'
        })

        // Game Pass настроен правильно
        this.$store.commit('setScipGamepass', true)
        this.$analytics.send('purch_trans_4_gamepass', {})

        // Проверка баланса
        const balance = this.$store.getters.balance
        const requiredAmount = this.$store.state.paymentsOrder.amount

        if (balance < requiredAmount) {
          // Очищаем флаг SuperPass в store для обычного Transfer
          this.$store.commit('paymentsOrder/setSuperPassData', {
            isSuperPass: false,
            superPassId: ''
          })

          // Если денег не хватает - открываем форму выбора способа оплаты
          this.$emit('changeModal', {
            modal: 'TransferPaymentMethod',
            data: [this.placeId, this.placeName, this.uid]
          })
          return
        }

        // Если баланса достаточно - идем на оплату
        this.$emit('changeModal', {
          modal: 'OrderConfirmation',
          data: [this.placeId, this.placeName, this.uid]
        })
        return
      }
      this.getPlaces()
    },
    goToTransferCharacters() {
      this.$emit('changeModal', {
        modal: 'TransferCharacters',
        data: [this.robloxUserId, this.choosedNickname]
      })
    },
    selectPlace(id, name, uid) {
      this.placeId = id
      this.placeName = name
      this.uid = uid
      this.isSelectPlace = true

      // Сохранение данных о выбранном place в store
      this.$store.commit('paymentsOrder/setPlaceData', {
        placeId: id,
        placeName: name,
        placeUniverseId: uid
      })
    },
    openPlaceModal() {
      this.isShowPlaceModal = true
    },
    validateRegionalPrice(gamepassItem) {
      return gamepassItem.regional_price
    },
    async checkGamepassSetup() {
      try {
        const res = await fetch(
          `https://transfer.backend-pier.com/get_passes/${this.uid}?robux_amount=${this.expectedGamepassPrice}`
        )
        const data = await res.json()

        if (data?.data?.length) {
          const gamepass = data.data[0]
          // Останавливаем покупку, если у пользователя включено региональное ценообразование
          if (this.validateRegionalPrice(data.data[0])) {
            return { isConfigured: false, gamepassId: gamepass.id }
          }
          // Проверяем совпадает ли цена Game Pass с ожидаемой
          if (gamepass.price === this.expectedGamepassPrice) {
            return { isConfigured: true, gamepassId: gamepass.id }
          }
        }

        return { isConfigured: false }
      } catch (error) {
        console.error('Error checking gamepass:', error)
        return { isConfigured: false }
      }
    }
  }
}
</script>

<style lang="scss">
@import './transferPrivatPlace';
</style>
